import {
  chakra,
  shouldForwardProp as chakraShouldForwardProp,
} from '@chakra-ui/react';
import { isValidMotionProp, motion } from 'framer-motion';

// Forward Framer Motion props and Chakra's default forwardable props.
const shouldForwardProp = (prop: string) =>
  isValidMotionProp(prop) || chakraShouldForwardProp(prop) || prop === 'children';

/**
 * Typed Chakra + Framer Motion wrappers.
 * Accepts both Chakra style props and MotionProps without TypeScript errors.
 *
 * Usage:
 *   <MotionBox initial={{ opacity: 0 }} animate={{ opacity: 1 }} ml="2rem">
 */
export const MotionBox = chakra(motion.div, { shouldForwardProp });
export const MotionNav = chakra(motion.nav, { shouldForwardProp });
export const MotionButton = chakra(motion.button, { shouldForwardProp });
export const MotionUl = chakra(motion.ul, { shouldForwardProp });
export const MotionLi = chakra(motion.li, { shouldForwardProp });
